export enum DeclarationDownloadType {
  acknowledgmentReceipt = 'acknowledgment_receipt',
  fiscalDeclaration = 'fiscal_declaration',
  vatDeclaration = 'vat_declaration',
  proofsOfFiling = 'proofs_of_filing',
  vatDeposit = 'vat_deposit'
}
